import React from 'react';

import styled from 'styled-components';

interface QuizBannerProps {
  bannerBGColor: string;
}

const QuizBanner = styled.div<QuizBannerProps>`
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  background-color: ${({ bannerBGColor }) => bannerBGColor};
  height: 64px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

const QuizBannerTitle = styled.div`
  ${({ theme }) => theme.subHeader.variants.subHeading4.textStyles}
  letter-spacing: 0px;
  text-align: center;
`;

const QuizBannerDescription = styled.div`
  ${({ theme }) => theme.subHeader.variants.subHeading1.textStyles}
  font-weight: 700;
  letter-spacing: 0px;
  text-align: center;
`;

interface BuilderQuizBannerProps {
  bannerBGColor: string;
  bannerTitle: string;
  bannerSubtitle: string;
}

const BuilderQuizBanner = ({
  bannerBGColor,
  bannerTitle,
  bannerSubtitle,
}: BuilderQuizBannerProps) => {
  return (
    <QuizBanner bannerBGColor={bannerBGColor}>
      <QuizBannerTitle>{bannerTitle}</QuizBannerTitle>
      <QuizBannerDescription>{bannerSubtitle}</QuizBannerDescription>
    </QuizBanner>
  );
};

export default BuilderQuizBanner;
